import { Modal, Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import AnimationLoading from "../../../components/Animationloading";
import { convertCurrency, numberFormat } from "../../../helper";

const formatAttributes = (attributeValues = []) => {
  if (!Array.isArray(attributeValues) || attributeValues.length === 0) return "-";
  return attributeValues
    .map((attr) => {
      const name = attr?.attribute?.name || "";
      const value = attr?.value || "";
      return name ? `${name}${value ? `: ${value}` : ""}` : value;
    })
    .filter(Boolean)
    .join(", ");
};

function ProductVariantModal({
  show,
  onHide,
  variants,
  loading,
  onSelectVariant,
  parentProduct,
}) {
  const { t } = useTranslation();

  return (
    <Modal size="lg" show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>
          {/* {t("product_variant_list")} */}
          {parentProduct?.name ? `${parentProduct.name}` : ""}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading ? (
          <AnimationLoading />
        ) : variants?.length > 0 ? (
          <Table bordered responsive style={{ fontSize: 13 }}>
            <thead>
              <tr>
                <th>#</th>
                <th>{t("product_name_tb", { defaultValue: "Product" })}</th>
                <th>{t("tb_option", { defaultValue: "Options" })}</th>
                <th>{t("qty_name_tb", { defaultValue: "Qty" })}</th>
                <th>{t("price_name_tb", { defaultValue: "Price" })}</th>
              </tr>
            </thead>
            <tbody>
              {variants.map((variant, index) => {
                const attrs = formatAttributes(variant?.attributeValues);
                const isOut = (variant?.amount ?? 0) <= 0;
                return (
                  <tr
                    key={variant?.id || index}
                    style={{ cursor: "pointer", color: isOut ? "red" : "" }}
                    onClick={() => onSelectVariant(variant)}>
                    <td>{index + 1}</td>
                    <td>{variant?.product?.name ?? parentProduct?.name ?? "-"}</td>
                    <td>{attrs}</td>
                    <td style={{ fontWeight: isOut ? "bold" : "normal" }}>
                      {numberFormat(variant?.amount ?? 0)}
                    </td>
                    <td>
                      <span style={{ marginRight: 6 }}>
                        {convertCurrency(variant?.currency)}
                      </span>
                      {numberFormat(variant?.price ?? 0)}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        ) : (
          <div style={{ textAlign: "center", padding: "2rem", color: "#6B7280" }}>
            {t("empty_name_list", { defaultValue: "No data" })}
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
}

export default ProductVariantModal;
